export default __webpack_public_path__ + "static/media/mrw-canarias.3c69099c.svg";